import { useCallback, useLayoutEffect, useRef, useState } from "react";

export const useScrollbarState = ({ isEnabled }: { isEnabled: boolean }) => {
  const contentRef = useRef<HTMLDivElement | null>(null);
  const [hasVisibleScrollbar, setHasVisibleScrollbar] = useState(false);

  const updateScrollbarVisibility = useCallback(() => {
    const contentElement = contentRef.current;
    if (contentElement === null) {
      return;
    }

    const scrollContainer = contentElement.parentElement;
    if (scrollContainer === null) {
      return;
    }

    setHasVisibleScrollbar(scrollContainer.scrollHeight > scrollContainer.clientHeight);
  }, []);

  useLayoutEffect(() => {
    if (!isEnabled) {
      setHasVisibleScrollbar(false);
      return;
    }

    const contentElement = contentRef.current;
    if (contentElement === null) {
      return;
    }

    const scrollContainer = contentElement.parentElement;
    if (scrollContainer === null) {
      return;
    }

    updateScrollbarVisibility();

    const resizeObserver = new ResizeObserver(updateScrollbarVisibility);
    resizeObserver.observe(scrollContainer);
    resizeObserver.observe(contentElement);
    window.addEventListener("resize", updateScrollbarVisibility);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", updateScrollbarVisibility);
    };
  }, [isEnabled, updateScrollbarVisibility]);

  return {
    contentRef,
    hasVisibleScrollbar,
  };
};
